export default __webpack_public_path__ + "static/media/3.42a22028.jpg";